import {ListKeyManagerOption} from '@angular/cdk/a11y';
import {
    Component,
    Input,
    OnInit,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';

import {MatCarouselSlide} from './carousel-slide';
import {environment} from '../../../../../../../environments/environment';

@Component({
    selector: 'lib-carousel-slide',
    templateUrl: './carousel-slide.component.html',
    styleUrls: ['./carousel-slide.component.scss'],
    standalone: true
})
export class MatCarouselSlideComponent
    implements ListKeyManagerOption, MatCarouselSlide, OnInit {
    @Input() public image: any | SafeStyle;
    @Input() public urlRelative = true;
    @Input() public overlayColor = '#00000040';
    @Input() public hideOverlay = false;
    @Input() public disabled = false; // implements ListKeyManagerOption

    @ViewChild(TemplateRef) public templateRef: TemplateRef<any>;

    constructor(public sanitizer: DomSanitizer) {
    }

    public ngOnInit(): void {
        if (this.image) {
            if (this.urlRelative) {
                this.image = environment.urlApi + this.image.replace('/', '');
            }

            this.image = this.sanitizer.bypassSecurityTrustStyle(`url("${this.image}")`);
        }
    }
}
